import { render, staticRenderFns } from "./persona-resumen.vue?vue&type=template&id=7318e066&scoped=true&"
import script from "./persona-resumen.component.ts?vue&type=script&lang=ts&"
export * from "./persona-resumen.component.ts?vue&type=script&lang=ts&"
import style0 from "./persona-resumen.vue?vue&type=style&index=0&id=7318e066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318e066",
  null
  
)

export default component.exports